import { FC, useMemo, useState } from 'react';

import { AIChatThread } from '@atom/types/ai';

import RenameModal from '../common/RenameModal';

export type ChatThreadRenameModalProps = {
  threadId: string;
  threads: AIChatThread[];
  open: boolean;
  onClose: () => void;
  onRename: (threadId: string, title: string) => Promise<any>;
};

const ChatThreadRenameModal: FC<ChatThreadRenameModalProps> = ({
  threadId,
  threads,
  open,
  onClose,
  onRename,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const name = useMemo(() => {
    if (!threadId) {
      return '';
    }

    const thread = threads.find(thr => thr.id === threadId);

    return thread ? thread.title : '';
  }, [threadId, threads]);

  const handleRename = async (id: string, updated: string) => {
    setLoading(true);

    await onRename(id, updated);

    setLoading(false);

    onClose();
  };

  return (
    <RenameModal
      id={threadId}
      open={open}
      name={name}
      type="Chat"
      title="Rename Chat?"
      confirmText="Save"
      renameAction={handleRename}
      closeModal={onClose}
      loading={loading}
    />
  );
};

export default ChatThreadRenameModal;
